import type { SVGProps } from "react";
export interface Arrow04RightIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Arrow04RightIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Arrow04RightIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m13.097 1.882.167.02c.377.07.65.277.784.383.178.14.38.334.577.521l6.995 6.64c.305.29.585.555.798.794.221.248.441.544.57.926a2.63 2.63 0 0 1 0 1.676c-.129.381-.349.677-.57.925-.213.24-.493.504-.798.794l-6.995 6.64c-.197.187-.4.38-.577.522-.152.12-.488.375-.95.403a1.63 1.63 0 0 1-1.343-.577c-.297-.355-.344-.772-.361-.966-.02-.226-.02-.506-.02-.777V16.63H4.4c-.401 0-.77.001-1.077-.024a3 3 0 0 1-.756-.15l-.259-.112a2.63 2.63 0 0 1-1.147-1.147 2.7 2.7 0 0 1-.262-1.015c-.025-.307-.023-.677-.023-1.078v-2.2c0-.402-.002-.772.023-1.078.026-.32.086-.67.262-1.016a2.63 2.63 0 0 1 1.147-1.147l.26-.11c.259-.093.515-.132.755-.152.307-.025.676-.023 1.077-.023h6.975V4.202c0-.271 0-.552.02-.778.017-.194.064-.61.361-.965l.132-.14c.278-.26.638-.415 1.018-.437h.192ZM3.125 13.104c0 .439 0 .701.016.895.014.18.037.2.025.176.036.07.093.128.164.164l.011.003c.025.005.075.014.164.022.194.015.456.016.894.016h8.1c.622 0 1.125.504 1.125 1.125v3.543l6.446-6.118c.333-.317.533-.507.67-.66.073-.083.104-.128.115-.146a.38.38 0 0 0 0-.24 1 1 0 0 0-.116-.147 13 13 0 0 0-.67-.659l-6.444-6.12v3.545c0 .62-.504 1.125-1.126 1.125H4.4c-.438 0-.7 0-.894.016a1 1 0 0 0-.164.022l-.011.003a.38.38 0 0 0-.164.164c.012-.025-.01-.004-.025.176-.016.194-.016.456-.016.895z"
      />
    </svg>
  );
}
